import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Route from 'react-router-dom/Route';
import Redirect from 'react-router-dom/Redirect';
import { connect } from 'react-redux';
import LayoutContainer from 'common/layout/LayoutContainer.js';
import { actionCreators as loginStore } from 'common/auth/store.js';
import UserData from 'common/sessionStore/userPreferences.js';
import TermsAndConditionsContainer from 'common/termsAndConditions/TermsAndConditionsContainer.js';

class PrivateRoute extends Component {
  constructor(props) {
    super(props);
    this.props.checkLogin();
    this.userData = new UserData();
  }

  componentDidMount() {
    //record my current route so that I can come back after oidc invokes LoginCallback
    this.userData.setRequestedPath(
      this.props.location.pathname + this.props.location.search
    );
    window.scroll(0, 0);
  }

  render() {
    const {
      isAuthenticated,
      hasAcceptedTC,
      userId,
      component,
      path,
      hideMenu,
      ...rest
    } = this.props;
    return (
      <Route
        {...rest}
        path={path}
        render={() => {
          return isAuthenticated ? (
            !(hasAcceptedTC || this.userData.getTcAccepted(userId)) ? (
              <LayoutContainer>
                <TermsAndConditionsContainer showModal={true} />
              </LayoutContainer>
            ) : (
              <LayoutContainer hideMenu={hideMenu}>
                <this.props.component />
              </LayoutContainer>
            )
          ) : (
            <Redirect to="/Login" />
          );
        }}
      />
    );
  }
}

PrivateRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  hasAcceptedTC: PropTypes.bool,
  component: PropTypes.func,
  path: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    userId: state.auth.userId,
    isAuthenticated: state.auth.isAuthenticated,
    hasAcceptedTC: state.auth.hasAcceptedTC,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkLogin: () => {
      dispatch(loginStore.checkLogin());
    },
  };
};

export default connect(mapStatetoProps, mapDispatchToProps)(PrivateRoute);
